import { useIntl } from "gatsby-plugin-intl"
import Banner from "../images/driver-mockup.png"
import React, { Fragment } from "react"
import { Row, Col, Button } from "react-bootstrap"

const BannerDriver = ({ siteTitle }) => {
  const intl = useIntl()

  return (
    <Fragment>
      <Row
        className={"mb-5 py-5 px-3 d-flex align-items-center"}
        style={{ marginTop: 160 }}
      >
        <Col
          md={4}
          className={"d-flex justify-content-center position-absolute"}
        >
          <img
            alt={"passenger"}
            src={Banner}
            height={600}
            className={"d-none d-sm-block"}
          />
        </Col>
        <div className={"d-block d-sm-none p-3"}></div>
        <Row
          style={{ backgroundColor: "#AD1457", padding: 20 }}
          className={"py-4 justify-content-end"}
        >
          <Col md={7} style={{ color: "white" }}>
            <h1>{intl.formatMessage({ id: "wanna-driver" })}</h1>
            <p>{intl.formatMessage({ id: "wanna-driver-desc" })}</p>
            <a href="https://wa.me/6285601386594">
              <Button
                className={
                  "btn-primary btn-shadow-primary rounded-pill mt-4 px-4"
                }
                style={{
                  fontWeight: "bold",
                  backgroundColor: "white",
                  color: "#AD1457",
                }}
              >
                {intl.formatMessage({ id: "learn-more" })}
              </Button>
            </a>
          </Col>
        </Row>
      </Row>
    </Fragment>
  )
}

BannerDriver.propTypes = {}

BannerDriver.defaultProps = {
  siteTitle: ``,
}

export default BannerDriver
